import React, { FC, useState, useEffect } from 'react'
import { isAuthorRealName, OutputAuthorType, UserType } from '../types/models/User'
import UserAvatar from './UserAvatar'

type Props = {
    author: OutputAuthorType
}

export const CommentUserAvator: FC<Props> = ( { author } ) => {
    console.log( "!", author )

    return (
        <div>
            <UserAvatar
                userID={ author.pk }
                userName={ author.name }
                profileImageURL={ author.profile_image_100 }
            />
        </div>
    )
}
